<section
   class="support-tab-body versions"
   [attr.data-component]="'ncx/support/versions'">
   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="July 29th, 2025"
      icon="code">
      <ul>
         <li>
            <span class="bold">Clickable post titles:</span>
            Post titles are once again hyperlinks, enabling quick copy/paste of post titles with links intact.
         </li>
         <li>
            <span class="bold">Historical Linked Requests:</span>
            Older Breaking News and Bureau Cam requests now appear in the NCX Related Content tab.
         </li>
         <li>
            <span class="bold">Thumbnail fixes:</span>
            Fixed an issue where thumbnails for uploaded video and doc files were not appearing.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="June 12th, 2025"
      icon="code">
      <p><span class="bold">Introducing: Slack Reportable Bot!</span></p>
      <ul>
         <li>
            <span class="bold">Mark Slack messages as Reportable to send them directly to NCX:</span>
            Users can now mark any Slack message as “Reportable,” automatically creating a post in NewsConnect. This
            removes manual steps and ensures high-priority information is captured instantly.
         </li>
         <li>
            <span class="bold">Editorial labels now travel from Slack to NCX:</span>
            Apply labels such as
            <span class="bold">Hot, Important, Do Not Use, Cleared,</span>
            or
            <span class="bold">Embargoed</span>
            within Slack. The post will reflect these tags in NCX with matching priority designations and visual cues.
         </li>
         <li>
            <span class="bold">Embargoed content respects scheduled timing:</span>
            Messages tagged as Embargoed in Slack will not appear in NCX until the specified embargo time has
            passed—supporting accurate timing and control.
         </li>
         <li>
            <span class="bold">Full metadata mapping for transparency and tracking:</span>
            Posts sent from Slack include creator and modifier names, source approver, and timestamps—preserving audit
            trails for editorial governance.
         </li>
         <li>
            <span class="bold">Map Slack channels to NCX stories for faster tagging:</span>
            Each Slack channel can be pre-mapped to a default NCX story, making it faster to route messages.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="May 1st, 2025"
      icon="code">
      <p><span class="bold">New Features</span></p>
      <ul>
         <li>
            <span class="bold">New search highlight:</span>
            Search terms will now have a purple highlight to make it easier to identify where they appear in the results
         </li>
         <li>
            <span class="bold">People & Groups search:</span>
            These tabs have been redesigned for a more efficient searching experience
         </li>
         <li>
            <span class="bold">New video icon:</span>
            Videos will now have a play icon, making it easier to distinguish between playable video and images
         </li>
         <li>
            <span class="bold">Enhanced classification logic:</span>
            If a post mentions a REM or Media ID it will be considered an element for filtering, but is no longer
            mislabeled as a video
         </li>
      </ul>
      <p><span class="bold">Bug Fixes</span></p>
      <ul>
         <li>
            <span class="bold">Related Content tabs:</span>
            Improvements to linked bookings
         </li>
         <li>
            <span class="bold">Link Issue:</span>
            Resolved copy/paste issues with images and links
         </li>
         <li>
            <span class="bold">Slack Alerts:</span>
            Fixed an issue that impacted a very small number of alerts sent to Slack
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="March 12th, 2025"
      icon="code">
      <ul>
         <li>
            <span class="bold">Linked Producer Dashboard Requests:</span>
            Related Crew, Edit, Feed Out, and File Ingest requests are now displayed in the Related Content tab in
            NewsConnect
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="February 27th, 2025"
      icon="code">
      <p><span class="bold">Linked Guest Bookings</span></p>

      <ul>
         <li>
            <span class="bold">Related Content:</span>
            A new tab within a story to see related Guest Tracker bookings
         </li>
      </ul>

      <nz-divider></nz-divider>

      <p><span class="bold">Search</span></p>

      <ul>
         <li>
            <span class="bold">Redesigned Search Bar:</span>
            More visually prominent search bar design
         </li>
         <li>
            <span class="bold">Search history:</span>
            View your most recent searches in the redesigned search bar
         </li>
         <li>
            <span class="bold">Searchable Post Tags:</span>
            Tags added to posts are now searchable
         </li>
         <li>
            <span class="bold">Story Tag Enhancements:</span>
            Story metadata will now be enhanced by updates from posts, making it easier to find the right story
         </li>
         <li>
            <span class="bold">Email Signature Elements:</span>
            Going forward, email signatures will no longer be classified as elements when searching & filtering
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="November 13th, 2024"
      icon="code">
      <p><span class="bold">Story ID</span></p>

      <ul>
         <li>
            <span class="bold">Story ID:</span>
            A new automated human-readable unique ID will be generated for all new stories
         </li>
         <li>
            <span class="bold">Required Topics:</span>
            Topics will be required for all new Stories and part of Story ID
         </li>
         <li>
            <span class="bold">Searchability:</span>
            You will be able to search and filter based on Story ID
         </li>
      </ul>

      <nz-divider></nz-divider>

      <p><span class="bold">Global Navigation</span></p>

      <ul>
         <li>
            <span class="bold">Application Navigation Menu:</span>
            New app menu box in the righthand corner allows you to easily navigate to other Newsroom tools
         </li>
         <li>
            <span class="bold">Support Page:</span>
            New support section with FAQ, Training Videos and Version History pages
         </li>
         <li>
            <span class="bold">Lefthand Navigation Reorganization:</span>
            Order and functionality of lefthand navigation has been updated
         </li>
      </ul>

      <nz-divider></nz-divider>

      <p><span class="bold">Search</span></p>

      <ul>
         <li>
            <span class="bold">Ignoring Articles:</span>
            Words that are not relevant to search keywords (such as “the”/”but”/”of”) will no longer be picked up as
            keywords in search, improving result relevancy
         </li>
         <li>
            <span class="bold">Country Synonyms:</span>
            Search results surface non-exact Country matches. For example, searching “Ukraine” will surface “Ukranian”
            results (other examples include Argentina/Argentine, Bahamas/Bahamian)
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="October 3rd, 2024"
      icon="code">
      <ul>
         <li>
            <span class="bold">Element Previews:</span>
            Videos, PDF's and Word elements now display thumbnail previews of the actual file in NewsConnect without
            having to download the file
         </li>
         <li>
            <span class="bold">Back button functionality:</span>
            Clicking "back" in post landing pages will now always take you back to the associated parent story
         </li>
         <li>
            <span class="bold">Restoring archived posts:</span>
            Fix for bug where creator name was overwritten when restoring archived posts
         </li>
         <li>
            <span class="bold">Mediacentral Integration Improvements:</span>
            Media ID standardization for multiple attachments and implementation for all elements
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="August 15th, 2024"
      icon="code">
      <p><span class="bold">Angle Beta Improvements</span></p>

      <ul>
         <li>
            <span class="bold">Private Angles:</span>
            Create private angles for your in-progress work so that material and information is only visible to you and
            your collaborators.
         </li>
      </ul>

      <nz-divider></nz-divider>

      <p><span class="bold">MediaCentral Integration</span></p>

      <ul>
         <li>
            <span class="bold">Unique Media IDs for Video Uploads:</span>
            Video file uploads now get unique auto-generated Media IDs (like archived video in MAM).
         </li>
         <li>
            <span class="bold">Media ID Field Fix:</span>
            The Media ID field that appears in NewsConnect after you send a video to WG01/06 now displays the correct
            Media ID instead of MOB ID.
         </li>
         <li>
            <span class="bold">Improved Metadata:</span>
            Metadata for Cleared videos sent to MediaCentral will now also include NewsConnect Story Name, Capture Date,
            Creator, and (coming soon) Story ID
         </li>
      </ul>

      <nz-divider></nz-divider>

      <p><span class="bold">Other New Features &amp; Fixes</span></p>

      <ul>
         <li>
            <span class="bold">Standardized Video Element Names:</span>
            Video file downloads will automatically follow a new standard naming convention.
         </li>
         <li>
            <span class="bold">Slack Channel for Standards Alerts:</span>
            All Standards alerts from NewsConnect will be sent automatically to a dedicated Slack channel
            <a
               href="https://nbcuniversal.enterprise.slack.com/archives/C073U5S8JF8"
               target="_blank"
               rel="noopener noreferrer"
               (click)="trackOutboundLink('https://nbcuniversal.enterprise.slack.com/archives/C073U5S8JF8')">
               #newsconnect-standards-alerts
            </a>
         </li>
         <li>
            <span class="bold">Fixes for Boolean Operators:</span>
            Bug fixes for AND/OR/NOT Boolean search operators.
         </li>
         <li>
            <span class="bold">Fixes for NCX App in Slack:</span>
            All NewsConnect alerts sent to Slack now include Standards guidance and should appear faster and more
            reliably.
         </li>
         <li>
            <span class="bold">PDF Previews:</span>
            View previews of PDFs directly in NewsConnect without having to download the file
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="May 9th, 2024"
      icon="code">
      <ul>
         <li>New Angle feature (beta)</li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="January 18th, 2024"
      icon="code">
      <ul>
         <li>
            <span class="bold">Followed Stories:</span>
            Under the
            <a
               href="/#/ncx/followed-stories"
               (click)="trackOutboundLink('/#/ncx/followed-stories')"
               rel="noopener noreferrer"
               target="_blank">
               Following
            </a>
            tab, you'll now find a page for Stories that lets you review and unfollow stories quickly.
         </li>
         <li>
            <span class="bold">NCX in Slack Alerts:</span>
            Push notifications now include the post title instead of the URL.
         </li>
         <li>
            <span class="bold">NCX in Slack Story Channels:</span>
            We now have guardrails to prevent accidentally unsubscribing a channel from NCX alerts.
         </li>
         <li>
            <span class="bold">Links on Mobile:</span>
            We've fixed mobile links so they now open to the correct page in NCX instead of the homepage.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="September 12th, 2023"
      icon="code">
      <ul>
         <li>
            <span class="bold">Published Video Stories:</span>
            Cut video published to the websites will automatically appear in 4 new NCX stories:
         </li>
         <li>
            <ng-container
               *ngTemplateOutlet="
                  storyLink;
                  context: { id: '1694490067731', text: 'Published Video Content - All' }
               "></ng-container>
         </li>
         <li>
            <ng-container
               *ngTemplateOutlet="
                  storyLink;
                  context: { id: '1694490111228', text: 'Published Video Content - MSNBC' }
               "></ng-container>
         </li>

         <li>
            <ng-container
               *ngTemplateOutlet="
                  storyLink;
                  context: { id: '1694490125820', text: 'Published Video Content - Nightly News' }
               "></ng-container>
         </li>

         <li>
            <ng-container
               *ngTemplateOutlet="
                  storyLink;
                  context: { id: '1694490090295', text: 'Published Video Content - Today' }
               "></ng-container>
         </li>

         <li>
            <span class="bold">Tab Name Updates:</span>
            Browser tab shows detailed page names instead of just "NewsConnect"
         </li>
         <li>
            <span class="bold">New Slack Channel:</span>
            The full text of all HOT and Important updates now send instantly to
            <a
               href="https://nbcnewstechnology.createsend1.com/t/d-i-vtduykd-l-k/"
               (click)="trackOutboundLink('https://nbcnewstechnology.createsend1.com/t/d-i-vtduykd-l-k/')"
               rel="noopener noreferrer"
               target="_blank">
               #newsconnect-hot-important
            </a>
            in Slack
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="April 12th, 2022"
      icon="code">
      <ul>
         <li>
            Ability to Send Cleared Video to WG01/06
            <a
               href="https://nbcuni.sharepoint.com/sites/NewsProduct/Lists/NewsConnect/AllItems.aspx?env=WebViewList&ct=1721750910020&or=Teams%2DHL&LOF=1&viewid=f064a052%2D98cc%2D4c87%2Dbb91%2D8da027c2abbc&playlistLayout=playback&itemId=8"
               (click)="
                  trackOutboundLink(
                     'https://nbcuni.sharepoint.com/sites/NewsProduct/Lists/NewsConnect/AllItems.aspx?env=WebViewList&ct=1721750910020&or=Teams%2DHL&LOF=1&viewid=f064a052%2D98cc%2D4c87%2Dbb91%2D8da027c2abbc&playlistLayout=playback&itemId=8'
                  )
               "
               rel="noopener noreferrer"
               target="_blank">
               Watch video
            </a>
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="March 17th, 2022"
      icon="code">
      <ul>
         <li>
            <span class="bold">Log Label:</span>
            Use the new Log label as an additional way to identify posts in NewsConnect that contain logs! When you add
            the label to your post, others can search and filter for Logs in NewsConnect more easily.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="December 16th, 2021"
      icon="code">
      <ul>
         <li>
            <span class="bold">"Did you mean...?":</span>
            Misspell a search term and the system will suggest a correction or alternate term. Click on the suggested
            term to run your search again with the correct spelling.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="December 1st, 2021"
      icon="code">
      <ul>
         <li>
            <span class="bold">Relevancy Refinements:</span>
            When posts include all your search terms, they will appear higher in relevance search results.
         </li>
         <li>
            <span class="bold">REM & MediaID Recognition:</span>
            Include a REM or MediaID in a post and NewsConnect will identify it as a video for better discoverability
            and filtering.
         </li>
         <li>
            <span class="bold">Search for Tagged Stories:</span>
            If tags were added when creating a story, they are now searchable.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="November 4th, 2021"
      icon="code">
      <ul>
         <li>
            <span class="bold">Dark Mode:</span>
            Change your preferred view from standard to dark mode.
         </li>
         <li>
            <span class="bold">Collapsed Navigation:</span>
            Collapse the left navigation and the app will remember that setting until you open it again.
         </li>
         <li>
            <span class="bold">Relevancy Search:</span>
            Sort search results to find content more relevant to your terms.
         </li>
         <li>
            <span class="bold">Search Result Count:</span>
            See how many results your search term generated.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="September 23rd, 2021"
      icon="code">
      <ul>
         <li>
            <span class="bold">Keyword Bold:</span>
            When you search, your keywords will show up in
            <span class="bold">purple bold</span>
            in the results.
         </li>
         <li>
            <span class="bold">Keyword in Context:</span>
            You now get a preview of where your keyword appears in the post description.
         </li>
         <li>
            <span class="bold">New Filters:</span>
            You can now filter elements by PDF and Word documents.
         </li>
         <li>
            <span class="bold">Search on Element Details Fields:</span>
            Information you enter into the Credit Name and Link to Source fields for elements are now searchable.
         </li>
         <li>
            <span class="bold">Tech Upgrade:</span>
            Behind the scenes, we've given the technical framework a big upgrade!
         </li>
         <li>
            <span class="bold">iOS 15 App Fix:</span>
            We've pushed out a new version of the mobile app that is compatible with iOS 15.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="June 3rd, 2021"
      icon="code">
      <ul>
         <li>
            The label sections are now divided into
            <span class="bold">Editorial/Standards</span>
            and
            <span class="bold">R&C/Legal</span>
         </li>
         <li>
            One new label has been added to the Editorial/Standards section:
            <span class="bold">Not Reportable</span>
         </li>
         <li>
            Two new labels have been added to the R&C/Legal section:
            <span class="bold">Licensed and Limited License</span>
         </li>
         <li>
            Use these labels to more accurately describe the status of licensing agreements and explain access or
            restrictions to video we've obtained or are trying to obtain.
         </li>
         <li>Four labels have been retired: Flagged, Buzzworthy, Logistics, and Under Review.</li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="April 28th, 2021"
      icon="code">
      <ul>
         <li>
            <span class="bold">Submitted Column Retired:</span>
            Now just navigate between stories in Working and Ready.
         </li>
         <li>
            <span class="bold">Story Slug Field Removed:</span>
            Slugs will no longer be needed when creating stories.
         </li>
         <li>
            <span class="bold">Feed Page Hidden:</span>
            The Feed page has been removed from the navigation, but you can still reach the page if you have it
            bookmarked.
         </li>
         <li>
            <span class="bold">New "Published/Aired" Label:</span>
            Use this new label to identify content that has been published or made it to air.
         </li>
         <li>
            <span class="bold">HOT Label Color Change:</span>
            The HOT label now has a red outline and text with a white background.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="April 16th, 2021"
      icon="code">
      <ul>
         <li>
            <span class="bold">Linking Emailed Posts:</span>
            Posts added to multiple stories via email are now linked to those stories instead of creating duplicate
            posts in each.
         </li>
         <li>
            <span class="bold">New Search Filters:</span>
            Advanced filters are now available when searching for stories.
         </li>
         <li>
            <span class="bold">Search with Special Characters:</span>
            Use special characters like &commat; when searching.
         </li>
         <li>
            <span class="bold">Improved In-Story Search:</span>
            The search bars in each story now use the same algorithm as the main magnifying glass search.
         </li>
         <li>
            <span class="bold">Post History in Profile:</span>
            See the history of posts someone has created when viewing their profile.
         </li>
      </ul>
   </app-collapsable>

   <app-collapsable
      title="Release Notes"
      iconTheme="outline"
      altText="March 25th, 2021"
      icon="code">
      <p><span class="bold">Search Improvements</span></p>

      <ul>
         <li>Search for exact phrases using quotation marks (e.g. "AstraZeneca revises vaccine data").</li>
         <li>See element pictures/thumbnails while searching.</li>
         <li>Results appear in order of most recently modified for stories and posts.</li>
         <li>When you hit enter, you will be defaulted to the Post results tab instead of the Stories tab.</li>
      </ul>

      <nz-divider></nz-divider>

      <p><span class="bold">Design and Experience Improvements</span></p>

      <ul>
         <li>Increased post title font size.</li>
         <li>Groups tab now ordered by most recently modified.</li>
         <li>In search preview pane, Stories and People sections have been swapped.</li>
      </ul>
   </app-collapsable>
</section>

<ng-template
   #storyLink
   let-id="id"
   let-text="text">
   <a
      href="https://newsconnect.nbcuni.com/#/ncx/landing-story/:{{ id }}"
      (click)="trackOutboundLink('/#/ncx/landing-story/:' + id)"
      rel="noopener noreferrer"
      target="_blank">
      {{ text || 'Story Link' }}
   </a>
</ng-template>
